import { render } from "./SettingsClientCategories.vue?vue&type=template&id=6f96f818&scoped=true"
import script from "./SettingsClientCategories.vue?vue&type=script&lang=js"
export * from "./SettingsClientCategories.vue?vue&type=script&lang=js"

import "./SettingsClientCategories.vue?vue&type=style&index=0&id=6f96f818&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6f96f818"]])

export default __exports__